
export default function Google({section}){

    if( !section.contentUrl ) return <>Document indisponible</>

    let urlParams = '?embedded=true';
    const src = section.contentUrl + urlParams;

    const style = {
        width: '96%',
        height: '99%',
        padding: '0px 2%',
    };

    return <iframe 
            title={section.title}
            src={src}
            style={style}
            border="0"
            frameBorder="0"
        >
            Document indisponible
    </iframe>


}